import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Checkbox } from "../Checkbox";
import { Flex } from "../Flex";
import { Icon } from "../Icon";
import { Typography } from "../Typography";
import { Placeholder } from "./interfaces";
import { ButtonUnSelectOption, StyledSelectItem } from "./styles";
export function SelectItem({ label, value, isMulti, disabled, selectedValue, isAllSelected, radixComponents, hideUnSelectButton, onClick, onUnSelectOption, }) {
    const isSelected = selectedValue === value;
    const stringifiedValue = typeof value !== "string" ? JSON.stringify(value) : value;
    const fallbackValue = stringifiedValue || Placeholder.Value;
    const canUnSelect = isSelected && !hideUnSelectButton;
    const ContentWrapper = radixComponents?.itemText || Flex;
    const getCheckboxValue = (value) => {
        if (value === "MASSIVE_ACTION") {
            if (isAllSelected)
                return [value];
            return undefined;
        }
        return selectedValue?.includes(stringifiedValue) ? [stringifiedValue] : undefined;
    };
    return (_jsx(StyledSelectItem, { as: radixComponents?.item, value: fallbackValue, "data-state": isSelected ? "checked" : "unchecked", disabled: disabled || isSelected, onClick: onClick, children: _jsxs(ContentWrapper, { width: "100%", children: [isMulti && (_jsx(Flex, { children: _jsx(Checkbox, { name: stringifiedValue, onChange: () => { }, typographyProps: { variant: 'Paragraph/Regular', cursor: 'pointer' }, initialValue: getCheckboxValue(stringifiedValue), autoCapitalize: false, options: [{
                                label,
                                value: stringifiedValue
                            }] }) })), !isMulti && (_jsxs(Flex, { alignItems: "center", justifyContent: "space-between", width: "100%", children: [_jsx(Typography, { className: "label-field", as: "span", variant: "Paragraph/Regular", textEllipsis: 1, title: typeof label === 'string' ? label : undefined, children: label }), (canUnSelect) && (_jsx(ButtonUnSelectOption, { type: "button", onClick: (e) => {
                                e.stopPropagation();
                                onUnSelectOption();
                            }, children: _jsx(Icon, { name: "close", color: "--text-link", size: "20px" }) }))] }))] }) }));
}
//# sourceMappingURL=Item.js.map